import SignInModalEmailOnly from '@/app-shell/auth/sign-in-modal/sign-in-modal-email-only';
import { getTempUserId } from '@/utils/tempUser';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export const EVIDENCE_SIGNUP_REDIRECT_KEY = 'evidence_signup_redirect';

export interface SignUpPromptModalChatProps {
  isOpen: boolean;
  onClose: () => void;
  /** @deprecated No longer used - email-only modal has its own title */
  title?: string;
  /** @deprecated No longer used - email-only modal has its own subtitle */
  subtitle?: string;
  /** Query to preserve through the signup redirect so it auto-sends after login */
  query?: string;
  /** Explicit chat ID to redirect to after signup. Falls back to router.query.id when not provided. */
  chatId?: string;
}

/**
 * Sign up modal specifically for the logged-out /chat route.
 * Routes new users through /scribe/new-user for onboarding, then redirects to /scribe/chat.
 */
export const SignUpPromptModalChat = ({
  isOpen,
  onClose,
  query,
  chatId: chatIdProp,
}: SignUpPromptModalChatProps) => {
  const router = useRouter();

  const chatId = chatIdProp ?? router.query.id?.[0];

  const finalDestination = chatId ? `/scribe/chat/${chatId}` : '/scribe/chat';
  const queryParam = query ? `?query=${encodeURIComponent(query)}` : '';
  const tempUserId = getTempUserId();
  const tempUserParam = tempUserId ? `&tempUserId="${tempUserId}"` : '';
  const redirectUrl = `/scribe/new-user#redirectTo="${finalDestination}${queryParam}"&signupSource="evidence"${tempUserParam}`;

  // Store redirect URL in sessionStorage as a fallback for auth flows
  // (e.g. Google OAuth) where Kinde's post_login_redirect_url may be lost.
  // Cleared on modal close so it doesn't trigger unexpected redirects.
  useEffect(() => {
    if (isOpen) {
      sessionStorage.setItem(EVIDENCE_SIGNUP_REDIRECT_KEY, redirectUrl);
    } else {
      sessionStorage.removeItem(EVIDENCE_SIGNUP_REDIRECT_KEY);
    }
  }, [isOpen, redirectUrl]);

  return (
    <SignInModalEmailOnly
      shouldBlurOverlay={true}
      isOpen={isOpen}
      postLoginRedirectUri={redirectUrl}
      isOnboardingRoute={true}
      signupSource="evidence"
      onOpenChange={onClose}
      dismissible={true}
    />
  );
};
